import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { persons } from '../../../models/persons'; // Importing persons model
import { devConfig } from '../../../config/config'; // Importing development configuration

export default class InformationView extends JetView {
    // Defining InformationView class extending JetView
    config() {
        // Method to define the view configuration
        const _ = this.app.getService('locale')._; // Getting localization service
        const main_info = {
            // Main information layout configuration
            margin: 20,
            minWidth: 200,
            cols: [
                {
                    margin: 10,
                    rows: [
                        {
                            view: 'text', // Text input for Total Deposits
                            name: 'TotalDeposit',
                            label: _('Total Depósitos'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Depósitos'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Sports Stakes
                            name: 'TotalSportStakes',
                            label: _('Total Apuestas Deportivas'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Apuestas Deportivas'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Sports Winnings
                            name: 'TotalSportWinnings',
                            label: _('Total Ganancias Deportivas'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Ganancias Deportivas'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Casino Stakes
                            name: 'TotalCasinoStakes',
                            label: _('Total Apuestas Casino'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Apuestas Casino'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Casino Winnings
                            name: 'TotalCasinoWinnings',
                            label: _('Ganancias Totales Casino'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Ganancias Totales Casino'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Withdrawals
                            name: 'TotalWithdrawal',
                            label: _('Total Retiros'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Retiros'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Adjustments Entry
                            name: 'AdjustmentE',
                            label: _('Total Ajustes Entrada'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Ajustes Entrada'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Adjustments Exit
                            name: 'AdjustmentS',
                            label: _('Total Ajustes Salida'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Ajustes Salida'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                    ],
                },
            ],
        };
        const more_info = {
            // Additional information layout configuration
            margin: 20,
            minWidth: 200,
            cols: [
                {
                    margin: 10,
                    id: 'templateCol', // ID for the template column
                    rows: [
                        {
                            view: 'template', // Template view for loading indicator
                            id: 'templateResume', // ID for the template
                            template:
                                "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        },
                    ],
                },
            ],
        };
        const left_main = {
            // Left main layout configuration
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Including main_info in rows
        };
        const upper_section = {
            // Upper section layout configuration for larger screens
            id: 'a1',
            scroll: true,
            rows: [
                {
                    margin: 30,
                    cols: [main_info, more_info], // Including main_info and more_info in columns
                },
            ],
        };
        const upper_section_mobile = {
            // Upper section layout configuration for mobile screens
            scroll: true,
            rows: [
                {
                    margin: 30,
                    cols: [more_info], // Only including more_info in columns
                },
            ],
        };
        webix.ui.fullScreen(); // Setting the UI to full screen mode
        return {
            view: 'form', // Form view
            height: 0,
            rows: [
                screen.width > 500 && screen.height > 500 // Conditional rendering based on screen size
                    ? upper_section
                    : upper_section_mobile,
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
    init(form) {
        // Initialization method for the view
        const _ = this.app.getService('locale')._; // Getting localization service
        webix.ready(function () {
            // Webix ready event
            webix.attachEvent('onRotate', function (orientation) {
                // Event for screen rotation
                window.location.reload(); // Reloading the page on rotation
            });
        });
        this.on(this.app, 'customer:updateFinance', (id) => {
            // Event listener for updating finance
            const test = this; // Reference to the current instance
            webix
                .ajax() // AJAX request to fetch client KPI
                .get(devConfig.geturlApi() + 'Client/GetClientKpi', 'id=' + id, {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! '); // Displaying error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        text = JSON.parse(text); // Parsing the response
                        var shtml = // HTML string for displaying the summary
                            '<div style=" width: 100%;height: 100%;overflow: scroll;"> <h2>' +
                            _('Resumen') +
                            '</h2> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Depositos:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalDeposit) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Apuestas en Deportivas:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalSportStakes) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Apuestas en Casino:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalCasinoStakes) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Total Apuestas:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalCasinoStakes + text[0].TotalSportStakes) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Premios en Deportivas:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalSportWinnings) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Premios en Casino:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalCasinoWinnings) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Total Premios:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalSportWinnings + text[0].TotalCasinoWinnings) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Notas pendientes:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalPendingWithdrawal) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Valor Retirado:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalWithdrawal) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Bonos:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalBonus) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Bonos Free Ganados:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; float: right; "></div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalBonusWin) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Ajustes Entrada:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].AdjustmentE) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Ajustes Salida:') +
                            ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].AdjustmentS) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('GGR:') +
                            ' </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalCasinoStakes +
                                    text[0].TotalSportStakes -
                                    (text[0].TotalSportWinnings + text[0].TotalCasinoWinnings) -
                                    text[0].TotalBonus,
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                            _('Rejuego:') +
                            ' </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                (text[0].TotalCasinoStakes + text[0].TotalSportStakes) / text[0].TotalDeposit,
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;font-weight: bold;"> <div style=" display: inline-block; ">' +
                            _('Total:') +
                            ' </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                (
                                    text[0].TotalDeposit -
                                    text[0].TotalSportStakes -
                                    text[0].TotalCasinoStakes +
                                    text[0].TotalSportWinnings +
                                    text[0].TotalCasinoWinnings -
                                    text[0].TotalPendingWithdrawal -
                                    text[0].TotalWithdrawal +
                                    text[0].TotalBonus +
                                    text[0].AdjustmentE -
                                    text[0].AdjustmentS
                                ).toFixed(2),
                                { decimalSize: 2 },
                            ) +
                            '</div>  </div>' +
                            '</div>';
                        $$('templateResume').setHTML(shtml); // Setting the HTML content of the template
                        $$('templateCol').hide(); // Hiding the loading template
                        $$('templateCol').show(); // Showing the updated template
                        test.app.callEvent('customer:updatedataFinance', [
                            text[0], // Triggering event with updated finance data
                        ]);
                    },
                });
        });
        this.app.callEvent('customer:updateFinance', [
            this.getParam('user', true), // Triggering finance update event with user parameter
        ]);
        this.on(
            this.app,
            'customer:updatedataFinance',
            (
                person, // Event listener for updated finance data
            ) => form.setValues(person), // Setting form values with updated data
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for person selection
    }
    getLocalizedComboOptions() {
        // Method to get localized options for combo boxes
        const _ = this.app.getService('locale')._; // Getting localization service
        let p_options = webix.copy(getPositions()); // Copying positions data
        p_options.map((x) => (x.value = _(x.value))); // Localizing position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parsing positions into combo box
        let t_options = webix.copy(getTags()); // Copying tags data
        t_options.map((x) => (x.value = _(x.value))); // Localizing tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parsing tags into combo box
        let c_options = webix.copy(getCities()); // Copying cities data
        c_options.map((x) => (x.value = _(x.value))); // Localizing city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parsing cities into combo box
    }
}

// FILE DOCUMENTED
